import { RootState } from '../store';

export const getTableGroups = (state: RootState) => state.groups.table;

export const getGroupName = (state: RootState) => {
    return (id: string) =>  {
        const group = state.groups.all.find((e) => e.id === id);
        if (group) {
            return group.name || group.id;
        } else {
            return '...'; // id;
        }
    };
};

export const groupOptions = (state: RootState) => {
    return state.groups.all.map((group) => {
        return {
            label: group.name,
            value: group.id,
        };
    });
};

export const groupOptionsPerWorkspace = (state: RootState) => {

    return state.groups.perWorkspace.map((group) => {
        return {
            label: group.name,
            value: group.id,
        };
    });
};

export const getSingleGroup = (state: RootState) => state.groups.singleGroup;